import red from '@material-ui/core/colors/red';
import yellow from '@material-ui/core/colors/yellow';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';

const styles = () => ({
    resetContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    resetButton: {
      backgroundColor: '#f74747'
    },
    input: {
      paddingRight: '3px'
    },
    cardOne: {
      backgroundColor: 'gray',
      marginBottom: '14px',
      padding: '4px 2px'
    },
    cardTwo: {
      backgroundColor: '#c2c3c3', //#a0a0a0 darker grey
      marginBottom: '14px',
      padding: '4px 2px'

    },
    arrow: {
      textAlign: 'center',
      paddingTop: '12px !important'
    },
    root: {
      width: "100%",
    },
    header: {
      backgroundColor: "#121212",
      color: "#fff",
    },
    bg0: {
      backgroundColor: '#cecece'
    },
    bg1: {
      backgroundColor: '#fff'
    },
    hidden: {
      // The grid item's padding normally balances with the negative padding
      // of the container outside the Collapse.
      // But when the collapse hides its content, the padding of the item
      // is still taking up space, creating an unwanted space.
      // The 'hidden' style rule is only applied when the collapse finishes
      // hiding its content
      padding: '0 !important',
    },
    marginTop: {
      marginTop: '0px'
    },
    center: {
      display: 'flex',
      justifyContent: 'center'
    },
    time: {
      fontSize: '.98rem'
    },
    mobileText: {
      paddingLeft: '0px !important',
      paddingRight: '0px !important'
    },
  'Unknown': { color: grey[500] },
  'OnTime': { background: green[500] },
  'Arrived': { background: green[500] },
  'Departed': { background: green[500] },
  'Delayed': { background: yellow[500] },
  'Cancelled': { background: red[500] }
  });
  
  export default styles;
  


// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/styles.js